import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import styles from './Header.module.css';
import { ChevronRightButton, ChevronDownButton } from '_components';
import { getDateMDYY } from '_helpers'

class PatientHomeCdvHeader extends React.Component {

    getChevron() {
        if (this.props.visible) {
            return (<ChevronDownButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleVisibility(this.props.admission.id)} />)
        } else {
            return (<ChevronRightButton size='extra-small' className={styles.header_button} onClick={() => this.props.toggleVisibility(this.props.admission.id)} />)
        }
    }

    render() {
        if (this.props.admission.dischargeDate == null) {
            return (
                <div className={styles.admission_header}>
                    {this.getChevron()}
                    <span className={styles.header_text}>{
                        getDateMDYY(this.props.admission.startDate)
                        + ' - ' + this.props.admission.desc
                        + ' - ' + this.props.admission.discipline
                        + ' - ' + this.props.admission.lcid
                    }
                    </span>
                </div>
            );
        } else {
            return (
                <div className={styles.admission_header}>
                    {this.getChevron()}
                    <span className={styles.header_text}>{
                        getDateMDYY(this.props.admission.startDate)
                        + ' - ' + getDateMDYY(this.props.admission.dischargeDate)
                        + ' - ' + this.props.admission.desc
                        + ' - ' + this.props.admission.discipline
                        + ' - ' + this.props.admission.lcid
                    }
                    </span>
                </div>
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: bindActionCreators(patientActions.toggleCdvVisibility, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {
        admission: state.entities.admissions[ownprops.id],
        visible: state.ui.cdv[ownprops.id].visible
    };
}

const connectedPatientHomeCdvHeader = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdvHeader);
export { connectedPatientHomeCdvHeader as PatientHomeCdvHeader };

